import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'cookie_notice_dismissed';
const MARKETING_URL = import.meta.env.VITE_MARKETING_URL || 'https://www.caneta.ink';

export default function CookieNotice() {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(STORAGE_KEY) === 'true');

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:bottom-4 md:left-4 md:right-auto md:max-w-sm">
      <div className="bg-white border border-gray-warm/50 rounded-t-lg md:rounded-lg p-4 shadow-lg">
        <p className="text-sm text-sepia">
          {t('cookies.notice')}{' '}
          <a
            href={`${MARKETING_URL}/en/privacy`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue hover:underline font-medium"
          >
            {t('cookies.learnMore')}
          </a>
        </p>
        <button
          type="button"
          onClick={handleDismiss}
          className="mt-3 px-4 py-1.5 bg-ink text-cream rounded-md text-sm font-medium hover:bg-ink/90 transition-all"
        >
          {t('cookies.dismiss')}
        </button>
      </div>
    </div>
  );
}
